import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  z-index: 10100;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.46);
`;

export const WarningBox = styled.div`
  position: relative;
  width: 822px;
  min-height: 350px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
  padding: 0px 0px 30px 0px;
`

export const Title = styled.div`
  height: 96px;
  padding: 0px 58px 0px 58px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  display: flex;
  align-items: center;
`

export const Content = styled.div`
  padding: 0px 58px 38px 58px;
  max-height: 450px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  -webkit-align-content: space-between;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
`

export const Message = styled.div`
  padding: 24px 0px 0px 0px;
  flex-grow: 0;
  font-family: Roboto;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  white-space: pre-wrap;
`

export const FontsReplaceList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px 0px 00px 0px;
`

export const ActionsContainer = styled.div`
  padding: 60px 0px 0px 0px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`

export const Action = styled.div`
  min-width: 141px;
`